import { render, staticRenderFns } from "./ModalGerarCartaCorrecao.vue?vue&type=template&id=67941d64"
import script from "./ModalGerarCartaCorrecao.vue?vue&type=script&lang=js"
export * from "./ModalGerarCartaCorrecao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports